import { action, computed, makeObservable, observable } from "mobx";
import { IObservableInitialState } from "../../models/ICommon";
import { ICommonState } from "../../models/state/ICommonState";
import URLConstants from "../../constants/url-constants";
import * as baseService from "../service/base-service";
import IApiResponse, {
  IApiSuccessResponse,
} from "../../models/response/IApiResponse";
import { toast } from "react-hot-toast";
import { formatMessage } from "../../translations/format-message";
import {getBusinessTypeIdFromLocalStorage, getUserIdFromToken } from "../../helpers/localstorage-helper";
import { DATE_FORMAT, DATE_TIME_FORMAT, initialStateValue, safeBase64Encode } from "../../constants/constants";
import moment from "moment";
import { IAddAgreementRecord, IAddMedicalRecordImages, IAddSaleItemVM, IAgreementHistoryListVM, IAgreementRecordHistoryList, IAgreementRecordVM, IGetMedicalImageVM, IMedicalImagesVM, IMedicalRecordHistoryList, IMedicalRecordImagesList, IMedicalRecordListVM, ISaleItemVM, ISaleRecordList, ISMRAppointemntDetails, ISMRList, ISMRVM, IUpdateMedicalRecord, IUpdateMedicalRecordImage, IUpdateMedicalRecordOrderId } from "../../models/response/ISMRResponse";
import { initialState as salesAgreementRecordInitialState } from "../initialState/add-edit-sales-agreement-state";
import { SMRTabEnum } from "../../constants/enums/smr-tab-enum";
import base64 from "base-64";
import { ImageTypeEnum } from "../../constants/enums/image-type-enum";
import { IProductManagementVM } from "../../models/response/IProductManagementResponse";
import { saleRecordPaymentType } from "../../constants/enums/sale-record-payment-type-enum";
 
export class SMRStore implements ICommonState {
  inProgress = false;
  error = "";

  selectedBookingId: number = -1;
  activeTab: SMRTabEnum | string = SMRTabEnum.Sales;

  bookingList: any[] = [];
  bookingListState: ICommonState = { ...initialStateValue };

  salesRecord: ISMRVM | undefined = undefined;
  salesRecordState: ICommonState = { ...initialStateValue };

  addUpdateSaleRecordState: IObservableInitialState = { ...initialStateValue };
  deleteSaleRecordState: IObservableInitialState = { ...initialStateValue };
  deleteSMRState: IObservableInitialState = { ...initialStateValue };
  refundSaleRecordState: IObservableInitialState = { ...initialStateValue };

  addUpdatePaymentDetailsBySaleRecordIdState: IObservableInitialState = {
    ...initialStateValue,
  };

  registerSale: boolean = false;
  selectedSaleRecrodForCreatingNewSale: number = -1;

  selectedSMRCustomerId: number = -1;
  selectedAppointmentIdForPayment: number = -1;
  isDataChanged: boolean = false;
  isRegisterButtonClicked: boolean = false;

  salesAgreementRecord: IAgreementRecordVM | undefined = undefined;
  salesAgreementRecordState: ICommonState = { ...initialStateValue };

  addUpdateSaleAgreementRecordState: IObservableInitialState = {
    ...initialStateValue,
  };
  deleteSaleAgreementRecordState: IObservableInitialState = {
    ...initialStateValue,
  };

  salesAgreementRecordHistoryList: IAgreementRecordHistoryList[] = [];
  salesAgreementRecordHistoryListState: IObservableInitialState = {
    ...initialStateValue,
  };

  verifyNavigationPasswordForAgreementState: IObservableInitialState = {
    ...initialStateValue,
  };
  isNavigationPasswordNotSetForAgreementState: IObservableInitialState = {
    ...initialStateValue,
  };
  isNavigationPasswordNotSetForAgreement: boolean = false;
  openAccountHandler: boolean = false;

  medicalRecordList: IMedicalRecordHistoryList[] = [];
  medicalRecordListState: IObservableInitialState = { ...initialStateValue };

  medicalRecordImage: IGetMedicalImageVM | undefined = undefined;
  cmsStoreImage: IGetMedicalImageVM[] | undefined = undefined;
  cmsStoreImageState: IObservableInitialState = { ...initialStateValue };
  medicalRecordImageState: IObservableInitialState = { ...initialStateValue };
  addMedicalRecordImageState: IObservableInitialState = {
    ...initialStateValue,
  };
  updateMedicalRecordImageState: IObservableInitialState = {
    ...initialStateValue,
  };
  updateMedicalRecordState: IObservableInitialState = { ...initialStateValue };
  updateMedicalRecordOrderIdState: IObservableInitialState = {
    ...initialStateValue,
  };
  deleteMedicalRecordImageState: IObservableInitialState = {
    ...initialStateValue,
  };

  productBarcode: IAddSaleItemVM | undefined = undefined;
  productBarcodeState = { ...initialStateValue };

  isStaffAvailable: { status: boolean; errorMsg: string } = {
    status: false,
    errorMsg: "",
  };
  isStaffAvailableState = { ...initialStateValue };
  medicalRecordOffsetId: number = 0;
  medicalRecordIsScrollUp: boolean = false;
  updatedMedicalRecordSMRId: number = 0;
  toMedicalRecordFromBookingCard: boolean = false;

  downloadAgreementPDFSMRId: number = -1;
  openAccountingPopupSaleRecordId: number = -1;

  constructor() {
    makeObservable(this, {
      inProgress: observable,
      activeTab: observable,
      selectedBookingId: observable,
      cmsStoreImage: observable,
      cmsStoreImageState: observable,
      bookingList: observable,
      bookingListState: observable,
      salesRecord: observable,
      salesRecordState: observable,
      addUpdateSaleRecordState: observable,
      registerSale: observable,
      deleteSaleRecordState: observable,
      deleteSMRState: observable,
      refundSaleRecordState: observable,
      selectedSaleRecrodForCreatingNewSale: observable,
      selectedSMRCustomerId: observable,
      isDataChanged: observable,
      selectedAppointmentIdForPayment: observable,
      openAccountHandler: observable,

      addUpdatePaymentDetailsBySaleRecordIdState: observable,

      salesAgreementRecord: observable,
      salesAgreementRecordState: observable,
      addUpdateSaleAgreementRecordState: observable,
      deleteSaleAgreementRecordState: observable,
      salesAgreementRecordHistoryList: observable,
      salesAgreementRecordHistoryListState: observable,

      productBarcode: observable,
      productBarcodeState: observable,

      isStaffAvailable: observable,
      isStaffAvailableState: observable,

      medicalRecordList: observable,
      medicalRecordListState: observable,

      medicalRecordImage: observable,
      medicalRecordImageState: observable,
      addMedicalRecordImageState: observable,
      updateMedicalRecordImageState: observable,
      updateMedicalRecordState: observable,
      updateMedicalRecordOrderIdState: observable,
      deleteMedicalRecordImageState: observable,

      verifyNavigationPasswordForAgreementState: observable,
      isNavigationPasswordNotSetForAgreementState: observable,
      isNavigationPasswordNotSetForAgreement: observable,
      medicalRecordOffsetId: observable,
      medicalRecordIsScrollUp: observable,
      updatedMedicalRecordSMRId: observable,
      toMedicalRecordFromBookingCard: observable,

      downloadAgreementPDFSMRId: observable,
      openAccountingPopupSaleRecordId: observable,

      GetBookingListByCustomerIdService: action,
      GetSaleRecordListByBookingIdService: action,
      AddSaleRecordService: action,
      UpdateSaleRecordService: action,
      DeleteSaleRecordService: action,
      DeleteSMRService: action,
      RefundSaleRecordService: action,
      GetCMSImageByStoreIdImageTypeService: action,

      AddPaymentDetailsBySaleRecordIdService: action,
      UpdatePaymentDetailsBySaleRecordIdService: action,
      GetProductManagementByStoreIdAndBarcodeService: action,

      GetSaleRecordAgreementHistoryListService: action,
      GetSalesAgreementRecordStateBySMRIdService: action,
      setAgreementImageUploader: action,
      AddSalesAgreementRecordService: action,
      UpdateSalesAgreementRecordService: action,
      DeleteSalesAgreementRecordService: action,
      VerifyNavigationPasswordForAgreementService: action,
      VerifyIsNavigationPasswordNotSetForAgreementService: action,
      VerifyStaffIsAvailableOrNotService: action,

      GetMedicalRecordListService: action,
      GetMedicalRecordImageByImageIdService: action,
      AddMedicalRecordImagesService: action,
      UpdateMedicalRecordImageService: action,
      UpdateMedicalRecordService: action,
      UpdateMedicalRecordOrderIdService: action,
      DeleteMedicalRecordImageService: action,
      DeleteCMSStoreImageService: action,
      AddCMSSStoreImagesService: action,
      UpdateCMSStoreImagesOrderIdService: action,

      resetBookingListState: action,
      resetSalesRecordListState: action,
      resetAddUpdateSaleRecordState: action,
      resetDeleteSaleRecordState: action,
      resetDeleteSMRState: action,
      resetRefundSaleRecordState: action,

      resetAddUpdatePaymentDetailsBySaleRecordIdState: action,
      resetProductBarcodeState: action,

      resetSalesAgreementRecordHistoryListState: action,
      resetSalesAgreementRecordState: action,
      resetAddUpdateSalesAgreementRecordState: action,
      resetDseleteSaleAgreementRecordState: action,
      resetVerifyNavigationPasswordForAgreementState: action,
      resetIsNavigationPasswordNotSetForAgreementState: action,

      resetMedicalRecordListState: action,
      resetMedicalRecordImageState: action,
      resetAddMedicalRecordImageState: action,
      resetUpdateMedicalRecordImageState: action,
      resetUpdateMedicalRecordState: action,
      resetUpdateMedicalRecordOrderIdState: action,
      resetDeleteMedicalRecordImageState: action,

      resetIsStaffAvailableState: action,
      resetIsStaffAvailable: action,
      resetcmsStoreImageState: action,
      resetStore: action,

      setImageUploadLoader: action,
      setSelectedBookingId: action,
      setMedicalRecordOffsetId: action,
      setMedicalRecordIsScrollUp: action,
      setUpdatedMedicalRecordSMRId: action,
      setDownloadAgreementPDFSMRId: action,
      setToMedicalRecordFromBookingCard: action,
      setActiveTab: action,
      setRegisterSale: action,
      setSelectedSMRCustomerId: action,
      setIsDataChanged: action,
      setIsRegisterButtonClicked: action,
      setOpenAccountHandler: action,
      setSelectedAppointmentIdForPayment: action,
      setSelectedSaleRecrodForCreatingNewSale: action,
      setOpenAccountingPopupSaleRecordId: action,
      allBookingList: computed,
      allSalesRecord: computed,
      salesRecordAppointmentDetails: computed,
      // salesRecordAppointementStatus: computed,

      allSalesAgreementRecordHistory: computed,
      salesAgreementRecordDetail: computed,
      allMedicalRecord: computed,
      medicalRecordImageDetail: computed,
      allCMSStoreImages: computed
    });
  }

  /*
  This function is used to set the selected booking id.  
  */
  setSelectedBookingId = (id: number) => {
    this.selectedBookingId = id;
  };

  setMedicalRecordOffsetId = (id: number) => {
    this.medicalRecordOffsetId = id;
  };

  setMedicalRecordIsScrollUp = (status: boolean) => {
    this.medicalRecordIsScrollUp = status;
  };

  setToMedicalRecordFromBookingCard = (status: boolean) => {
    this.toMedicalRecordFromBookingCard = status;
  };

  setUpdatedMedicalRecordSMRId = (id: number) => {
    this.updatedMedicalRecordSMRId = id;
  };

  setDownloadAgreementPDFSMRId = (id: number) => {
    this.downloadAgreementPDFSMRId = id;
  };

  setActiveTab = (tab: SMRTabEnum | string) => {
    this.activeTab = tab;
  };

  setSelectedSaleRecrodForCreatingNewSale = (id: number) => {
    if(id > 0 && this.salesRecord && this.salesRecord.SaleRecord.length > 0){
      let newArray: any[] = [];
      let newItem = { ...this.salesRecord.SaleRecord[0] };
      newItem.PaymentType = 1;
      newItem.SaleRecordPaymentStatus = false;
      newItem.IsActiveRecord = true;
      newItem.Id = -1;
      newItem.Date = moment(newItem.Date).format(DATE_FORMAT);
      newItem.Time =
        moment(newItem.Time, "HH:mm:ss").format("HH:mm") || "00:00";
      newArray.push({...newItem})
      this.salesRecord = {...this.salesRecord, SaleRecord: [...newArray, ...this.salesRecord?.SaleRecord]}
      }
    this.selectedSaleRecrodForCreatingNewSale = id;
  };

  setSelectedSMRCustomerId = (id: number) => {
    this.selectedSMRCustomerId = id;
  };

  setIsDataChanged = (isDataChanged: boolean) => {
    this.isDataChanged = isDataChanged;
  };
  setIsRegisterButtonClicked = (isRegisterButtonClicked: boolean) => {
    this.isRegisterButtonClicked = isRegisterButtonClicked;
  };

  setOpenAccountHandler = (isAccountPopupOpen: boolean) => {
    this.openAccountHandler = isAccountPopupOpen;
  };
  
  setOpenAccountingPopupSaleRecordId = (openAccountingPopupSaleRecordId: number) => {
    this.openAccountingPopupSaleRecordId = openAccountingPopupSaleRecordId;
  };

  setSelectedAppointmentIdForPayment = (id: number) => {
    this.selectedAppointmentIdForPayment = id;
  };

  setRegisterSale = (status: boolean) => {
    this.registerSale = status;
  };

  /**
   * This function is used to Get Customer booking list Details by Id by calling an API.
   * @param id : The Customer Identifier
   * @returns
   */
  GetBookingListByCustomerIdService = (customerId: number, storeId: number) => {
    this.bookingListState.inProgress = true;
    // this.salesRecord = undefined;
    let url = `${URLConstants.GetSalesMedicalRecordList}?StoreId=${storeId}&CustomerId=${customerId}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any[]>>) => {
        if (response.data.Error) {
          this.bookingListState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          let data = response.data.Data;
          this.bookingList = data;
          if (this.selectedAppointmentIdForPayment > 0) {
            this.selectedBookingId =
              this.bookingList.filter(
                (record) =>
                  record.AppointmentId === this.selectedAppointmentIdForPayment
              )[0]?.Id || -1;
            this.selectedAppointmentIdForPayment = -1;
          } else if (this.selectedBookingId < 0 && this.bookingList?.length > 0)
            this.selectedBookingId =
              this.bookingList?.length > 0 ? this.bookingList[0]?.Id : -1;
        }
      })
      .catch((err: string) => {
        this.bookingListState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.bookingListState.inProgress = false;
        })
      );
  };

  /**
   * This function maps bookingList values to the corresponding list values suitable for rendering.
   * @returns booking list
   *
   */
  get allBookingList(): ISMRList[] {
    if (this.bookingList && this.bookingList?.length > 0) {
      return this.bookingList.map((booking) => {
        let date = booking.SMRGeneratedDate
            ? moment(booking.SMRGeneratedDate).format(DATE_FORMAT)
            : ""
        let time = booking.SMRGeneratedDate
            ? moment(booking.SMRGeneratedDate).format("HH:mm") ||
              "00:00"
            : "00:00"
        let sortedSaleRecord = booking.SaleRecord?.slice()?.sort((a: any, b: any) => b.Id - a.Id);
        return {
          Id: booking.Id,
          AppointmentId: booking.AppointmentId,
          CustomerId: booking.CustomerId,
          SMRGeneratedDate: booking.SMRGeneratedDate,
          StoreId: booking.StoreId,
          SaleRecord: sortedSaleRecord,
          Date: date,
          Time: time,
          Total: booking.SaleRecord ? booking.SaleRecord[0]?.Total : "",
          StaffId: booking.SaleRecord
            ? booking.SaleRecord[0]?.StaffId
              ? booking.SaleRecord[0]?.StaffId
              : ""
            : "",
          StaffName: booking.SaleRecord
            ? booking.SaleRecord[0]?.StaffName
              ? booking.SaleRecord[0]?.StaffName
              : ""
            : "",
        };
      });
    }
    return [];
  }

  /*
    This function is used to reset all bookingListState observables to their initial values.  
    */
  resetBookingListState = () => {
    this.bookingList = [];
    this.bookingListState = { ...initialStateValue };
  };

  /**
   * This function is used to Get sales record list Details by  booking Id by calling an API.
   * @param id : The booking Identifier
   * @returns
   */
  GetSaleRecordListByBookingIdService = (id: number) => {
    this.salesRecordState.inProgress = true;
    let url = `${URLConstants.GetSalesRecordById}/${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<ISMRVM>>) => {
        if (response.data.Error) {
          this.salesRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          let data = response.data.Data;
          this.salesRecord = data;
        }
      })
      .catch((err: string) => {
        this.salesRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.salesRecordState.inProgress = false;
        })
      );
  };

  /**
   * This function maps salesRecord values to the corresponding list values suitable for rendering.
   * @returns sales record list
   *
   */
  get allSalesRecord(): ISaleRecordList[] {
    let smrData: ISaleRecordList[] = [];
    if (
      this.salesRecord &&
      this.salesRecord?.SaleRecord &&
      this.salesRecord.SaleRecord?.length > 0
    ) {
      // g(this.systemUserList);
      this.salesRecord.SaleRecord?.map((item) => {
        let saleItem = item.SaleItem;
        smrData.push({
          ...item,
          DiscountType: item.DiscountType || 0,
          DiscountCash: item.DiscountCash || 0,
          DiscountPercent: item.DiscountPercent || 0,
          NominationFee: item.NominationFee || 0,
          Time: moment(item.Time, "HH:mm:ss").format("HH:mm") || "00:00",
          Date: moment(item.Date).format(DATE_FORMAT),
          TreatmentList: saleItem?.filter(
            (item: ISaleItemVM) => item.ItemType === 0
          ),
          ProductList: saleItem?.filter(
            (item: ISaleItemVM) => item.ItemType === 1
          ),
          SaleItem: saleItem?.map((saleitem: ISaleItemVM) => {
            return {
              ...saleitem,
              Quantity: saleitem.Quantity || 1,
              DiscountType: saleitem.DiscountType || 0,
              DiscountCash: saleitem.DiscountCash || 0,
              DiscountPercent: saleitem.DiscountPercent || 0,
              StaffId: saleitem.StaffId,
              Tax: saleitem.Tax || 0,
            };
          }),
        });
      });
    }
    // if (
    //   this.selectedSaleRecrodForCreatingNewSale > 0 &&
    //   this.salesRecord &&
    //   this.salesRecord?.SaleRecord &&
    //   this.salesRecord.SaleRecord?.length > 0
    // ) {
    //   let newSRArray = [];
    //   let newItem = { ...this.salesRecord?.SaleRecord[0] };
    //   newItem.PaymentType = 1;
    //   newItem.SaleRecordPaymentStatus = false;
    //   newItem.IsActiveRecord = true;
    //   newItem.Id = -1;
    //   newItem.Date = moment(newItem.Date).format(DATE_FORMAT);
    //   newItem.Time =
    //     moment(newItem.Time, "HH:mm:ss").format("HH:mm") || "00:00";
    //   newSRArray.push({
    //     ...newItem,
    //   });
    //   smrData = [...newSRArray, ...smrData];
    // }
    return smrData;
  }
  get salesRecordAppointmentDetails(): ISMRAppointemntDetails {
    if (this.salesRecord) {      
      return {
          Id: this.salesRecord.Id,
          AppointmentId: this.salesRecord.AppointmentId || 0,
          AppointmentStatus: this.salesRecord.AppointmentStatus,
          PostBreakTime: this.salesRecord.PostBreakTime || 0,
          CustomerId: this.salesRecord.CustomerId,
          SMRGeneratedDate: this.salesRecord.SMRGeneratedDate,
          StoreId: this.salesRecord.StoreId,
      };
    }
    else {
      return {
          Id: 0,
          AppointmentId: 0,
          AppointmentStatus: 0,
          PostBreakTime: 0,
          CustomerId: 0,
          SMRGeneratedDate: "",
          StoreId: 0,
      };
    }
  }

  // get salesRecordAppointementStatus(): string {
  //   if (this.salesRecord) {
  //     return this.salesRecord.AppointmentStatus !== null ? bookingStatusEnum[this.salesRecord.AppointmentStatus] : bookingStatusEnum[bookingStatusEnum.InProcess];
  //   }
  //     return bookingStatusEnum[bookingStatusEnum.InProcess];
  // }

  get getInitailAddSaleRecordDetails(): ISaleRecordList {
    return {
      Id: -1,
      SMRId: -1,
      AppointmentId: 0,
      CustomerId: 0,
      SMRGeneratedDate: moment(new Date()).format(DATE_TIME_FORMAT),
      StoreId: 0,
      PaymentType: 1,
      DiscountType: 0,
      DiscountCash: 0,
      DiscountPercent: 0,
      Time: moment(new Date(), "HH:mm:ss").format("HH:mm") || "00:00",
      Date: moment(new Date()).format(DATE_FORMAT),
      StaffId: 0,
      IsNominationApplied: false,
      ConsumptionTax: 0,
      IsActiveRecord: true,
      Total: 0,
      SaleItem: [],
      SaleRecordPaymentStatus: false,
      NominationFee: 0,
    };
  }

  /*
    This function is used to reset all salesRecordState observables to their initial values.  
    */
  resetSalesRecordListState = () => {
    this.salesRecord = undefined;
    this.salesRecordState = { ...initialStateValue };
  };

  AddSaleRecordService = (data: any, paymentMode: number) => {
    this.addUpdateSaleRecordState.inProgress = true;
    let url = URLConstants.AddSalesRecord;
    const BusinessTypeId = getBusinessTypeIdFromLocalStorage();
    return baseService
      .postRequest(url, {
        ...data,
        PaymentType: paymentMode,
        BusinessTypeId: Number(BusinessTypeId) > 0 ? BusinessTypeId : null,
      })
      .then((response: IApiResponse<IApiSuccessResponse<number>>) => {
        if (response.data.Error) {
          this.addUpdateSaleRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.selectedBookingId = response.data.Data ? response.data.Data : -1;
          this.addUpdateSaleRecordState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateSaleRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdateSaleRecordState.inProgress = false;
        })
      );
  };

  /**
   * This function is used to Updating Existing SaleRecord Details by calling an API.
   * @param id : The SaleRecord Identifier
   * @param data
   * @returns
   */
  UpdateSaleRecordService = (
    data: any,
    id: number,
    showAccountingPopup: boolean,
    smrId: number,
    customerId: number,
    storeId: number,
  ) => {
    this.addUpdateSaleRecordState.inProgress = true;
    let url = URLConstants.UpdateSalesRecordBySMRId;
    return baseService
      .putRequest(url, { ...data, Id: id, PaymentType: 1, SMRId: smrId, CustomerId: customerId, StoreId: storeId })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateSaleRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          if (showAccountingPopup){ 
            this.openAccountingPopupSaleRecordId = id;
            this.setOpenAccountHandler(true);
          }
          this.addUpdateSaleRecordState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateSaleRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdateSaleRecordState.inProgress = false;
        })
      );
  };

  resetAddUpdateSaleRecordState = () => {
    this.addUpdateSaleRecordState = { ...initialStateValue };
  };

  VerifyStaffIsAvailableOrNotService = (data: any) => {
    this.isStaffAvailableState.inProgress = true;
    let url = URLConstants.CheckIfStaffAlreadyConsumed;
    return baseService
      .postRequest(url, { ...data })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.isStaffAvailableState.error = response.data.Message;
          // toast.error(formatMessage(response.data.Message));
          this.isStaffAvailable = {
            status: false,
            errorMsg: response.data.Message,
          };
          this.isStaffAvailableState.success = true;
        } else {
          this.isStaffAvailableState.success = true;
          this.isStaffAvailable = { status: true, errorMsg: "" };
        }
      })
      .catch((err: string) => {
        this.isStaffAvailableState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.isStaffAvailableState.inProgress = false;
        })
      );
  };

  resetIsStaffAvailableState = () => {
    this.isStaffAvailableState = { ...initialStateValue };
  };

  resetIsStaffAvailable = () => {
    this.isStaffAvailable = { status: false, errorMsg: "" };
  };

  DeleteSaleRecordService = (id: number, closePopupHandler: () => void, lastRefundSaleRecordId: number) => {
    this.deleteSaleRecordState.inProgress = true;
    let url = URLConstants.DeleteSalesRecordBySMRId + "/" + id + "/SaleRecord" +
      "?LastRefundedSaleRecordId=" +
      lastRefundSaleRecordId;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteSaleRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.deleteSaleRecordState.success = true;
          closePopupHandler();
        }
      })
      .catch((err: string) => {
        this.deleteSaleRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.deleteSaleRecordState.inProgress = false;
        })
      );
  };

  resetDeleteSaleRecordState = () => {
    this.deleteSaleRecordState = { ...initialStateValue };
  };

  DeleteSMRService = (closePopupHandler: () => void, cancelationType: any) => {
    this.deleteSMRState.inProgress = true;
    let url =
      URLConstants.DeleteSalesRecordBySMRId +
      "/" +
      this.selectedBookingId +
      "?cancellationType=" +
      cancelationType;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteSMRState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.resetSalesRecordListState();
          this.setSelectedBookingId(-1);
          this.deleteSMRState.success = true;
          closePopupHandler();
        }
      })
      .catch((err: string) => {
        this.deleteSMRState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.deleteSMRState.inProgress = false;
        })
      );
  };

  resetDeleteSMRState = () => {
    this.deleteSMRState = { ...initialStateValue };
  };

  RefundSaleRecordService = (smrId: number, data: any) => {
    this.refundSaleRecordState.inProgress = true;
    let url = URLConstants.AddSalesRecord;
    let requestBody = {
      SMRId: data.SMRId,
      SaleId: data.Id,
      CustomerId: data.CustomerId,
      SMRGeneratedDate: moment(new Date()).format("YYYY-MM-DD ") + moment(new Date(), "HH:mm:ss").format("HH:mm"),
      StoreId: data.StoreId,
      PaymentType: saleRecordPaymentType.Debit, // Payment Type Debit
      DiscountType: data.DiscountType,
      DiscountCash: data.DiscountCash,
      DiscountPercent: data.DiscountPercent,
      Time: moment(new Date(), "HH:mm:ss").format("HH:mm") || "00:00",
      Date: moment(new Date()).format(DATE_FORMAT),
      StaffId: data.StaffId,
      IsNominationApplied: data.IsNominationApplied,
      ConsumptionTax: data.ConsumptionTax,
      IsActiveRecord: data.IsActiveRecord,
      Total: data.Total,
      SaleRecordPaymentStatus: true,
      NominationFee: data.NominationFee,
      SalesItemDetails: [...data.SaleItem],
    };
    return baseService
      .postRequest(url, requestBody)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.refundSaleRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.refundSaleRecordState.success = true;
      })
      .catch((err: string) => {
        this.refundSaleRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.refundSaleRecordState.inProgress = false;
        })
      );
  };

  resetRefundSaleRecordState = () => {
    this.refundSaleRecordState = { ...initialStateValue };
  };

  AddPaymentDetailsBySaleRecordIdService = (values: any) => {
    this.addUpdatePaymentDetailsBySaleRecordIdState.inProgress = true;
    let url = URLConstants.AddSMRPaymentDetailsBySaleRecordId;
    return baseService
      .postRequest(url, values)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdatePaymentDetailsBySaleRecordIdState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.addUpdatePaymentDetailsBySaleRecordIdState.success = true;
      })
      .catch((err: string) => {
        this.addUpdatePaymentDetailsBySaleRecordIdState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdatePaymentDetailsBySaleRecordIdState.inProgress = false;
        })
      );
  };

  UpdatePaymentDetailsBySaleRecordIdService = (values: any) => {
    this.addUpdatePaymentDetailsBySaleRecordIdState.inProgress = true;
    let url = URLConstants.UpdateSMRPaymentDetailsBySaleRecordId;
    return baseService
      .putRequest(url, values)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdatePaymentDetailsBySaleRecordIdState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
          toast.error(formatMessage(response.data.Message));
        } else this.addUpdatePaymentDetailsBySaleRecordIdState.success = true;
      })
      .catch((err: string) => {
        this.addUpdatePaymentDetailsBySaleRecordIdState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdatePaymentDetailsBySaleRecordIdState.inProgress = false;
        })
      );
  };

  resetAddUpdatePaymentDetailsBySaleRecordIdState = () => {
    this.addUpdatePaymentDetailsBySaleRecordIdState = { ...initialStateValue };
    if(this.openAccountingPopupSaleRecordId > 0)
      this.openAccountingPopupSaleRecordId = -1;
  };

  GetSaleRecordAgreementHistoryListService = (
    customerId: number,
    storeId: number
  ) => {
    this.salesAgreementRecordHistoryListState.inProgress = true;
    this.salesRecord = undefined;
    let url = `${URLConstants.GetAgreementRecordHistoryList}?CusId=${customerId}&StoreId=${storeId}`;
    return baseService
      .getRequest(url)
      .then(
        (
          response: IApiResponse<IApiSuccessResponse<IAgreementHistoryListVM>>
        ) => {
          if (response.data.Error) {
            this.salesAgreementRecordHistoryListState.error =
              response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            let data = response.data.Data;
            this.salesAgreementRecordHistoryList = data?.SMRVMs
              ? data?.SMRVMs
              : [];
          }
        }
      )
      .catch((err: string) => {
        this.salesAgreementRecordHistoryListState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.salesAgreementRecordHistoryListState.inProgress = false;
        })
      );
  };

  /**
   * This function maps bookingList values to the corresponding list values suitable for rendering.
   * @returns booking list
   *
   */
  get allSalesAgreementRecordHistory(): IAgreementRecordHistoryList[] {
    if (
      this.salesAgreementRecordHistoryList &&
      this.salesAgreementRecordHistoryList?.length > 0
    ) {
      return this.salesAgreementRecordHistoryList.map((agreement) => {
        return {
          Id: agreement.Id,
          Agreement: agreement.Agreement,
          SMRGeneratedDate: agreement.SMRGeneratedDate,
          AgreementSignOffDate:
            agreement?.Agreement && agreement.Agreement?.AgreementSignOffDate
              ? moment(agreement.Agreement?.AgreementSignOffDate).format(
                  DATE_FORMAT
                )
              : "",
          AgreementId: agreement.Agreement
            ? agreement.Agreement?.AgreementId
            : -1,
          SMRId: agreement.Agreement ? agreement.Agreement?.SMRId : -1,
          IsView: agreement.IsView,
          IsDelete: agreement.IsDelete,
        };
      });
    }
    return [];
  }

  /*
    This function is used to reset all salesAgreementRecordHistoryListState observables to their initial values.  
    */
  resetSalesAgreementRecordHistoryListState = () => {
    this.salesAgreementRecordHistoryList = [];
    this.salesAgreementRecordHistoryListState = { ...initialStateValue };
  };

  /**
   * This function is used to Get sales record list Details by  booking Id by calling an API.
   * @param id : The booking Identifier
   * @returns
   */
  GetSalesAgreementRecordStateBySMRIdService = (smrId: number) => {
    this.salesAgreementRecordState.inProgress = true;
    let url = `${URLConstants.GetAgreementRecordBySMRId}/id?SMRId=${smrId}`;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IAgreementRecordVM>>) => {
          if (response.data.Error) {
            this.salesAgreementRecordState.error = response.data.Message;
            this.salesAgreementRecord = {
              ...salesAgreementRecordInitialState,
              AgreementSignOffDate: moment(new Date()).format(DATE_TIME_FORMAT),
            };
          } else {
            let data = response.data.Data;
            this.salesAgreementRecord = data;
          }
        }
      )
      .catch((err: string) => {
        this.salesAgreementRecord = {
          ...salesAgreementRecordInitialState,
          AgreementSignOffDate: moment(new Date()).format(DATE_TIME_FORMAT),
        };
        this.salesAgreementRecordState.error = err;
      })
      .finally(
        action(() => {
          this.salesAgreementRecordState.inProgress = false;
        })
      );
  };

  /**
   * This function maps salesRecord values to the corresponding list values suitable for rendering.
   * @returns sales record list
   *
   */
  get salesAgreementRecordDetail(): IAgreementRecordVM {
    if (this.salesAgreementRecord) {
      return {
        Id: this.salesAgreementRecord.Id,
        SMRId: this.salesAgreementRecord.SMRId,
        AgreementSignOffDate: this.salesAgreementRecord.AgreementSignOffDate,
        Agreement: this.salesAgreementRecord.Agreement,
        AgreementId: this.salesAgreementRecord.AgreementId,
        AgreementImages: this.salesAgreementRecord.AgreementImages,
        Image: this.salesAgreementRecord.Image,
        IsSigned: this.salesAgreementRecord.IsSigned,
      };
    }
    return {
      ...salesAgreementRecordInitialState,
      AgreementSignOffDate: moment(new Date()).format(DATE_TIME_FORMAT),
    };
  }

  /*
    This function is used to reset all salesAgreementRecordState observables to their initial values.  
    */
  resetSalesAgreementRecordState = () => {
    this.salesAgreementRecord = undefined;
    this.salesAgreementRecordState = { ...initialStateValue };
  };

  setAgreementImageUploader = (loaderStatus: boolean) => {
    this.addUpdateSaleAgreementRecordState.inProgress = loaderStatus;
  };

  AddSalesAgreementRecordService = (
    data: IAddAgreementRecord,
    customerId: number
  ) => {
    this.addUpdateSaleAgreementRecordState.inProgress = true;
    let url = URLConstants.AddAgreementRecordBySMRId;

    const formData = new FormData();
    formData.append("SMRId", data.SMRId?.toString());
    formData.append("AgreementSignOffDate", data.AgreementSignOffDate);
    if (data.AgreementId)
      formData.append("AgreementId", data.AgreementId?.toString());
    if (customerId) formData.append("CustomerId", customerId?.toString());
    if (data.Agreement) formData.append("Agreement", data.Agreement);
    if (data.Image) formData.append("Image", data.Image);
    formData.append("IsSigned", data.IsSigned?.toString());
    if (data.AgreementImages && data.AgreementImages.length > 0) {
      //formData.append("AgreementImages", JSON.stringify(data.AgreementImages));

      data.AgreementImages.forEach((image, index) => {
        formData.append(
          `AgreementImages[${index}].ImageType`,
          image.ImageType.toString()
        );
        formData.append(
          `AgreementImages[${index}].ImageSource`,
          image.ImageSource || ""
        );
        formData.append(
          `AgreementImages[${index}].ImageBase64`,
          image.ImageBase64
        );
        formData.append(
          `AgreementImages[${index}].OrderId`,
          image.OrderId.toString()
        );
        formData.append(
          `AgreementImages[${index}].ThumbnailImage`,
          image.ThumbnailImage
        );
      });
    }
    return baseService
      .postMultipart(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateSaleAgreementRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addUpdateSaleAgreementRecordState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateSaleAgreementRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdateSaleAgreementRecordState.inProgress = false;
        })
      );
  };

  UpdateSalesAgreementRecordService = (data: any, id: number) => {
    this.addUpdateSaleAgreementRecordState.inProgress = true;
    let url = URLConstants.UpdateSalesRecordBySMRId;
    return baseService
      .putRequest(url, { ...data, Id: id })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateSaleAgreementRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.addUpdateSaleAgreementRecordState.success = true;
      })
      .catch((err: string) => {
        this.addUpdateSaleAgreementRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addUpdateSaleAgreementRecordState.inProgress = false;
        })
      );
  };

  resetAddUpdateSalesAgreementRecordState = () => {
    this.addUpdateSaleAgreementRecordState = { ...initialStateValue };
  };

  DeleteSalesAgreementRecordService = (id: number) => {
    this.deleteSaleAgreementRecordState.inProgress = true;
    let url =
      URLConstants.DeleteAgreementRecordBySMRId + "/" + this.selectedBookingId;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteSaleAgreementRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
          toast.error(formatMessage(response.data.Message));
        } else {
          this.setSelectedBookingId(-1);
          this.deleteSaleAgreementRecordState.success = true;
        }
      })
      .catch((err: string) => {
        this.deleteSaleAgreementRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.deleteSaleAgreementRecordState.inProgress = false;
        })
      );
  };

  resetDseleteSaleAgreementRecordState = () => {
    this.deleteSaleAgreementRecordState = { ...initialStateValue };
  };

  VerifyNavigationPasswordForAgreementService = (
    storeId: number,
    password: string
  ) => {
    this.verifyNavigationPasswordForAgreementState.inProgress = true;
    let url = URLConstants.VerifyNavigationPassword;
    return baseService
      .putRequest(url, { StoreId: storeId, Password: safeBase64Encode(password) })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.verifyNavigationPasswordForAgreementState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.verifyNavigationPasswordForAgreementState.success = true;
      })
      .catch((err: string) => {
        this.verifyNavigationPasswordForAgreementState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.verifyNavigationPasswordForAgreementState.inProgress = false;
        })
      );
  };

  resetVerifyNavigationPasswordForAgreementState = () => {
    this.verifyNavigationPasswordForAgreementState = { ...initialStateValue };
  };

  VerifyIsNavigationPasswordNotSetForAgreementService = (
    storeId: number,
    password: string
  ) => {
    this.isNavigationPasswordNotSetForAgreementState.inProgress = true;
    let url = URLConstants.VerifyNavigationPassword;
    return baseService
      .putRequest(url, { StoreId: storeId, Password: safeBase64Encode(password) })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.isNavigationPasswordNotSetForAgreement =
            response.data.Message === "PasswordNotSet";
          // this.isNavigationPasswordNotSetForAgreementState.error = response.data.Message;
          // toast.error(formatMessage(response.data.Message));
        } else {
          this.isNavigationPasswordNotSetForAgreementState.success = true;
          this.isNavigationPasswordNotSetForAgreement = true;
        }
      })
      .catch((err: string) => {
        this.isNavigationPasswordNotSetForAgreementState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.isNavigationPasswordNotSetForAgreementState.inProgress = false;
        })
      );
  };

  resetIsNavigationPasswordNotSetForAgreementState = () => {
    this.isNavigationPasswordNotSetForAgreementState = { ...initialStateValue };
    // this.isNavigationPasswordNotSetForAgreement = false;
  };

  GetMedicalRecordListService = (
    customerId: number,
    storeId: Number,
    offset: number,
    isScrollUp: boolean,
    isDataChanged: boolean = false,
    clearList: boolean = false
  ) => {
    this.medicalRecordListState.inProgress = true;
    let url = `${
      URLConstants.GetMedicalRecordList
    }?CusId=${customerId}&StoreId=${storeId}&Offset=${
      isDataChanged ? this.updatedMedicalRecordSMRId + 1 : offset
    }&NumberOfRecords=${5000}`;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IMedicalRecordListVM>>) => {
          if (response.data.Error) {
            this.medicalRecordListState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            let data = response.data.Data;
            if (clearList) {
              this.medicalRecordList = data.SMRVMs;
            } else {
              if (isDataChanged) {
                this.medicalRecordList = [
                  ...this.medicalRecordList.map(
                    (record: IMedicalRecordHistoryList) => {
                      if (record.Id === this.updatedMedicalRecordSMRId) {
                        let updatedMedicalRecordIndex = data.SMRVMs?.findIndex(
                          (item: IMedicalRecordHistoryList) =>
                            item.Id === this.updatedMedicalRecordSMRId
                        );
                        if (updatedMedicalRecordIndex > -1)
                          record.MedicalRecordVM = {
                            ...data.SMRVMs[updatedMedicalRecordIndex]
                              .MedicalRecordVM,
                          };
                      }
                      return record;
                    }
                  ),
                ];
              } else {
                if (isScrollUp)
                  this.medicalRecordList = [
                    ...data?.SMRVMs,
                    ...this.medicalRecordList.slice(0, 5),
                  ];
                else
                  this.medicalRecordList = [
                    ...this.medicalRecordList.slice(-5),
                    ...data?.SMRVMs,
                  ];
              }
            }
          }
        }
      )
      .catch((err: string) => {
        this.medicalRecordListState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.medicalRecordListState.inProgress = false;
        })
      );
  };

  /**
   * This function maps bookingList values to the corresponding list values suitable for rendering.
   * @returns booking list
   *
   */
  get allMedicalRecord(): IMedicalRecordImagesList[] {
    if (this.medicalRecordList && this.medicalRecordList.length > 0) {
      return this.medicalRecordList.map((medicalrecord) => {
        let allMedicalImages: IMedicalImagesVM[] =
          medicalrecord?.MedicalRecordVM?.MedicalImages?.length > 0
            ? [...medicalrecord.MedicalRecordVM.MedicalImages]
            : [];

        const groupedImages = {
          TemplateBefore: [] as IMedicalImagesVM[],
          TemplateAfter: [] as IMedicalImagesVM[],
          ImageBefore: [] as IMedicalImagesVM[],
          ImageAfter: [] as IMedicalImagesVM[],
        };

        allMedicalImages.forEach((image) => {
          switch (image.ImageType) {
            case ImageTypeEnum.TemplateBefore:
              groupedImages.TemplateBefore.push(image);
              break;
            case ImageTypeEnum.TemplateAfter:
              groupedImages.TemplateAfter.push(image);
              break;
            case ImageTypeEnum.ImageBefore:
              groupedImages.ImageBefore.push(image);
              break;
            case ImageTypeEnum.ImageAfter:
              groupedImages.ImageAfter.push(image);
              break;
          }
        });

        // Sort each image group by OrderId (undefined last)
        Object.keys(groupedImages).forEach((key) => {
          groupedImages[key as keyof typeof groupedImages].sort((a, b) => {
            const orderA = a.OrderId ?? Number.MAX_SAFE_INTEGER;
            const orderB = b.OrderId ?? Number.MAX_SAFE_INTEGER;
            return orderA - orderB;
          });
        });

        return {
          Id: medicalrecord.Id,
          SMRId: medicalrecord.MedicalRecordVM?.SMRId ?? -1,
          MedicalRecordId: medicalrecord.MedicalRecordVM?.Id ?? -1,
          Agreement: medicalrecord.Agreement,
          SMRGeneratedDate: medicalrecord.SMRGeneratedDate
            ? medicalrecord.SMRGeneratedDate
            : "",
          SMRVMs: medicalrecord.MedicalRecordVM?.SMRVMs ?? null,
          CounselingNote: medicalrecord.MedicalRecordVM?.CounselingNote ?? "",
          ReservationMemo: medicalrecord.MedicalRecordVM?.ReservationMemo ?? "",
          TemplateBefore: groupedImages.TemplateBefore,
          TemplateAfter: groupedImages.TemplateAfter,
          ImageBefore: groupedImages.ImageBefore,
          ImageAfter: groupedImages.ImageAfter,
        };
      });
    }
    return [];
  }

  get allCMSStoreImages(): IMedicalImagesVM[] {
    if (this.cmsStoreImage && this.cmsStoreImage?.length > 0) {
      return this.cmsStoreImage.map((storeImage) => {
        return {
          Id: storeImage.Id,
          MedicalRecordId: storeImage.MedicalRecordId,
          ImageType: storeImage.ImageType,
          ImageSource: storeImage.ImageSource,
          ImageBase64: storeImage.ImageBase64,
          OrderId: storeImage.OrderId,
          ThumbnailImage: storeImage.ThumbnailImage,
        };
      });
    }
    return [];
  }

  /*
    This function is used to reset all medicalRecordListState observables to their initial values.  
  */
  resetMedicalRecordListState = () => {
    this.medicalRecordList = [];
    this.medicalRecordListState = { ...initialStateValue };
  };

  /**
   * This function is used to Get sales record list Details by  booking Id by calling an API.
   * @param id : The booking Identifier
   * @returns
   */
  GetMedicalRecordImageByImageIdService = (id: number) => {
    this.medicalRecordImageState.inProgress = true;
    let url = `${URLConstants.GetMedicalRecordImageById}/${id}`;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IGetMedicalImageVM>>) => {
          if (response.data.Error) {
            this.medicalRecordImageState.error = response.data.Message;
          } else {
            let data = response.data.Data;
            this.medicalRecordImage = data;
          }
        }
      )
      .catch((err: string) => {
        this.medicalRecordImageState.error = err;
      })
      .finally(
        action(() => {
          this.medicalRecordImageState.inProgress = false;
        })
      );
  };

  GetCMSImageByStoreIdImageTypeService = (id: number, imageType: number) => {
    this.cmsStoreImageState.inProgress = true;
    let url = `${URLConstants.GetCMSImageByStoreIdImageType}?storeId=${id}&imageType=${imageType}`;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IGetMedicalImageVM[]>>) => {
          if (response.data.Error) {
            this.cmsStoreImageState.error = response.data.Message;
          } else {
            let data = response.data.Data;
            this.cmsStoreImage = data;
          }
        }
      )
      .catch((err: string) => {
        this.cmsStoreImageState.error = err;
      })
      .finally(
        action(() => {
          this.cmsStoreImageState.inProgress = false;
        })
      );
  };

  resetcmsStoreImageState = () => {
    this.cmsStoreImageState = {...initialStateValue};
    this.cmsStoreImage = undefined;
  }

  /**
   * This function maps salesRecord values to the corresponding list values suitable for rendering.
   * @returns sales record list
   *
   */
  get medicalRecordImageDetail(): IGetMedicalImageVM | undefined {
    if (this.medicalRecordImage) {
      return {
        Id: this.medicalRecordImage.Id,
        MedicalRecordId: this.medicalRecordImage.MedicalRecordId,
        ImageType: this.medicalRecordImage.ImageType,
        ImageSource: this.medicalRecordImage.ImageSource,
        ImageBase64: this.medicalRecordImage.ImageBase64,
        OrderId: this.medicalRecordImage.OrderId,
        ThumbnailImage: this.medicalRecordImage.ThumbnailImage,
      };
    }
    return undefined;
  }

  /*
    This function is used to reset all medicalRecordImageState observables to their initial values.  
    */
  resetMedicalRecordImageState = () => {
    this.medicalRecordImage = undefined;
    this.medicalRecordImageState = { ...initialStateValue };
  };

  setImageUploadLoader = () => {
    this.addMedicalRecordImageState.inProgress = true;
  };

  AddMedicalRecordImagesService = (
    data: IAddMedicalRecordImages,
    smrId: number
  ) => {
    this.addMedicalRecordImageState.inProgress = true;
    let url = URLConstants.AddMedicalRecord;
    const formData = new FormData();
    formData.append("data", JSON.stringify(data));
    return baseService
      .postMultipart(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addMedicalRecordImageState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addMedicalRecordImageState.success = true;
          this.updatedMedicalRecordSMRId = smrId;
        }
      })
      .catch((err: string) => {
        this.addMedicalRecordImageState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addMedicalRecordImageState.inProgress = false;
        })
      );
  };

  AddCMSSStoreImagesService = (data: any) => {
    this.addMedicalRecordImageState.inProgress = true;
    let url = URLConstants.AddCMSStoreImages;
    const formData = new FormData();
    data.medicalImagesDetails?.forEach((item:IGetMedicalImageVM, idx:number) => {
      Object.entries({...item, MedicalRecordId: data.MedicalRecordId}).forEach(([key, value]) => {
        formData.append(`CMSStoreImages[${idx}].${key}`, value);
      });
    });

    return baseService
      .postMultipart(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addMedicalRecordImageState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.addMedicalRecordImageState.success = true;
          // this.updatedMedicalRecordSMRId = smrId;
        }
      })
      .catch((err: string) => {
        this.addMedicalRecordImageState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.addMedicalRecordImageState.inProgress = false;
        })
      );
  };

  resetAddMedicalRecordImageState = () => {
    this.addMedicalRecordImageState = { ...initialStateValue };
  };

  UpdateMedicalRecordImageService = (
    data: IUpdateMedicalRecordImage,
    smrId: number
  ) => {
    this.updateMedicalRecordImageState.inProgress = true;
    let url = URLConstants.UpdateMedicalRecordImages;
    const formData = new FormData();
    formData.append("Id", data.Id?.toString());
    formData.append("MedicalRecordId", data.MedicalRecordId?.toString());
    formData.append("ImageType", data.ImageType?.toString());
    // formData.append("ImageSource", data.ImageSource);
    formData.append("ImageBase64", data.ImageBase64);
    formData.append("ThumbnailImage", data.ThumbnailImage);
    return baseService
      .putMultipart(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.updateMedicalRecordImageState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.updateMedicalRecordImageState.success = true;
          this.updatedMedicalRecordSMRId = smrId;
        }
      })
      .catch((err: string) => {
        this.updateMedicalRecordImageState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.updateMedicalRecordImageState.inProgress = false;
        })
      );
  };

  resetUpdateMedicalRecordImageState = () => {
    this.updateMedicalRecordImageState = { ...initialStateValue };
  };

  UpdateMedicalRecordService = (data: IUpdateMedicalRecord) => {
    this.updateMedicalRecordState.inProgress = true;
    let url = URLConstants.UpdateMedicalRecordNoteMemo;
    return baseService
      .putRequest(url, { ...data })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.updateMedicalRecordState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.updateMedicalRecordState.success = true;
          this.updatedMedicalRecordSMRId = data.SMRId;
        }
      })
      .catch((err: string) => {
        this.updateMedicalRecordState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.updateMedicalRecordState.inProgress = false;
        })
      );
  };

  resetUpdateMedicalRecordState = () => {
    this.updateMedicalRecordState = { ...initialStateValue };
  };

  UpdateMedicalRecordOrderIdService = (
    data: IUpdateMedicalRecordOrderId,
    smrId: number
  ) => {
    this.updateMedicalRecordOrderIdState.inProgress = true;
    let url = URLConstants.UpdateMedicalRecordImagesOrderId;
    return baseService
      .putRequest(url, { ...data })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.updateMedicalRecordOrderIdState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.updateMedicalRecordOrderIdState.success = true;
          this.updatedMedicalRecordSMRId = smrId;
        }
      })
      .catch((err: string) => {
        this.updateMedicalRecordOrderIdState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.updateMedicalRecordOrderIdState.inProgress = false;
        })
      );
  };

    UpdateCMSStoreImagesOrderIdService = (
    data: IUpdateMedicalRecordOrderId
  ) => {
    this.updateMedicalRecordOrderIdState.inProgress = true;
    let url = URLConstants.UpdateMedicalRecordImagesOrderId;
    return baseService
      .putRequest(url, { ...data })
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.updateMedicalRecordOrderIdState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.updateMedicalRecordOrderIdState.success = true;
        }
      })
      .catch((err: string) => {
        this.updateMedicalRecordOrderIdState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.updateMedicalRecordOrderIdState.inProgress = false;
        })
      );
  };

  resetUpdateMedicalRecordOrderIdState = () => {
    this.updateMedicalRecordOrderIdState = { ...initialStateValue };
  };

  DeleteMedicalRecordImageService = (
    id: number,
    medicalRecordId: number,
    orderId: number,
    smrId: number
  ) => {
    this.deleteMedicalRecordImageState.inProgress = true;
    let url = `${URLConstants.DeleteMedicalRecordImage}/${id}?MedicalRecordId=${medicalRecordId}&orderId=${orderId}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteMedicalRecordImageState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.updatedMedicalRecordSMRId = smrId;
          this.deleteMedicalRecordImageState.success = true;
        }
      })
      .catch((err: string) => {
        this.deleteMedicalRecordImageState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.deleteMedicalRecordImageState.inProgress = false;
        })
      );
  };

    DeleteCMSStoreImageService = (
    id: number,
    medicalRecordId: number,
    orderId: number
  ) => {
    this.deleteMedicalRecordImageState.inProgress = true;
    let url = `${URLConstants.DeleteMedicalRecordImage}/${id}?MedicalRecordId=${medicalRecordId}&orderId=${orderId}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteMedicalRecordImageState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.deleteMedicalRecordImageState.success = true;
        }
      })
      .catch((err: string) => {
        this.deleteMedicalRecordImageState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.deleteMedicalRecordImageState.inProgress = false;
        })
      );
  };

  resetDeleteMedicalRecordImageState = () => {
    this.deleteMedicalRecordImageState = { ...initialStateValue };
  };

  GetProductManagementByStoreIdAndBarcodeService = (
    storeId: number,
    barCode: string,
    formValues: any
  ) => {
    this.productBarcodeState.inProgress = true;
    let url = `${URLConstants.GetProductRegistartionStoreIdWithBarcode}?storeId=${storeId}&BarCode=${barCode}`;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IProductManagementVM>>) => {
          if (response.data.Error) {
            this.productBarcodeState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            let data = response.data.Data;
            this.productBarcode = {
              ItemType: 1,
              ItemId: data.Id,
              ItemName: data.ProductName,
              Quantity: 1,
              Price: data.PriceExcludingTax,
              Tax: data.TaxValue,
              TaxAmount: data.TaxAmount,
              DiscountType: 0,
              DiscountCash: 0,
              DiscountPercent: 0,
              StaffId: parseInt(formValues.StaffId),
              IsNominationApplied: false,
              TimeValue: null,
            };
            this.productBarcodeState.success = true;
          }
        }
      )
      .catch((err: string) => {
        this.productBarcodeState.error = err;
        toast.error(formatMessage(err));
      })
      .finally(
        action(() => {
          this.productBarcodeState.inProgress = false;
        })
      );
  };
  /*
      This function is used to reset all staff observables to their initial values.  
      */
  resetProductBarcodeState = () => {
    this.productBarcode = undefined;
    this.productBarcodeState = { ...initialStateValue };
  };

  resetStore = () => {
    this.inProgress = false;
    this.error = "";

    this.selectedBookingId = -1;
    this.bookingList = [];
    this.bookingListState = { ...initialStateValue };

    this.salesRecord = undefined;
    this.salesRecordState = { ...initialStateValue };

    this.addUpdateSaleRecordState = { ...initialStateValue };
    this.deleteSaleRecordState = { ...initialStateValue };
    this.deleteSMRState = { ...initialStateValue };
    this.refundSaleRecordState = { ...initialStateValue };

    this.addUpdatePaymentDetailsBySaleRecordIdState = { ...initialStateValue };

    this.registerSale = false;
    this.selectedSaleRecrodForCreatingNewSale = -1;

    this.salesAgreementRecord = undefined;
    this.salesAgreementRecordState = { ...initialStateValue };

    this.addUpdateSaleAgreementRecordState = { ...initialStateValue };
    this.deleteSaleAgreementRecordState = { ...initialStateValue };

    this.salesAgreementRecordHistoryList = [];
    this.salesAgreementRecordHistoryListState = { ...initialStateValue };

    this.verifyNavigationPasswordForAgreementState = { ...initialStateValue };
    this.isNavigationPasswordNotSetForAgreementState = { ...initialStateValue };
    this.isNavigationPasswordNotSetForAgreement = false;
  };
}
 
export default new SMRStore();